export const mapOptions = [
  {
    id: '2F_raon',
    floor: '2F 라온존',
    walkway_id: 4587,
    connected_id: [4585],
  },
  {
    id: '2F_atti',
    floor: '2F 아띠존',
    walkway_id: 4583,
    connected_id: [4585, 4582],
  },

  {
    id: '1F_raon',
    floor: '1F 라온존',
    walkway_id: 4585,
    connected_id: [4587, 4583, 4582, 4581],
  },
  {
    id: '1F_atti',
    floor: '1F 아띠존',
    walkway_id: 4582,
    connected_id: [4585, 4583, 4580, 4581],
  },
  {
    id: 'B1F',
    floor: 'B1 라온존',
    walkway_id: 4581,
    connected_id: [4585, 4580, 4582],
  },
  {
    id: 'B2F',
    floor: 'B2 주차장',
    walkway_id: 4580,
    connected_id: [4582, 4581],
  },
  {
    id: 'B3F',
    floor: 'B3 주차장',
    walkway_id: 4424,
    connected_id: [4580],
  },
];

export const spaceCoords1FRaon = [
  {
    zone: 'A101-1',
    coord: [
      [495, 1176],
      [557, 1176],
      [557, 1205],
      [475, 1205],
    ],
  },
  {
    zone: 'A101-2',
    coord: [
      [475, 1205],
      [557, 1205],
      [557, 1244],
      [462, 1244],
      [462, 1225],
    ],
  },
  {
    zone: 'A102-1',
    coord: [
      [462, 1244],
      [526, 1244],
      [526, 1308],
      [462, 1308],
    ],
  },
  {
    zone: 'A102-2',
    coord: [
      [526, 1244],
      [588, 1244],
      [588, 1308],
      [526, 1308],
    ],
  },
  {
    zone: 'A103',
    coord: [
      [686, 1233],
      [740, 1233],
      [750, 1256],
      [750, 1307],
      [686, 1307],
    ],
  },
  {
    zone: 'A104',
    coord: [
      [750, 1256],
      [810, 1225],
      [834, 1275],
      [770, 1307],
      [750, 1307],
    ],
  },
  {
    zone: 'A105-1',
    coord: [
      [797, 1195],
      [837, 1176],
      [874, 1256],
      [834, 1275],
    ],
  },
  {
    zone: 'A105-2',
    coord: [
      [837, 1176],
      [873, 1159],
      [912, 1237],
      [874, 1256],
    ],
  },
  {
    zone: 'A106-1',
    coord: [
      [810, 1067],
      [835, 1067],
      [863, 1128],
      [810, 1155],
    ],
  },
  {
    zone: 'A106-2',
    coord: [
      [768, 1067],
      [810, 1067],
      [810, 1155],
      [768, 1155],
    ],
  },
  {
    zone: 'A107-1',
    coord: [
      [721, 1067],
      [768, 1067],
      [768, 1118],
      [721, 1118],
    ],
  },
  {
    zone: 'A107-2',
    coord: [
      [680, 1067],
      [721, 1067],
      [721, 1118],
      [680, 1118],
    ],
  },
  {
    zone: 'A108',
    coord: [
      [630, 1067],
      [680, 1067],
      [680, 1155],
      [630, 1155],
    ],
  },
  {
    zone: 'A109',
    coord: [
      [581, 1067],
      [630, 1067],
      [630, 1155],
      [581, 1155],
    ],
  },
  {
    zone: 'A110',
    coord: [
      [565, 1067],
      [581, 1067],
      [581, 1155],
      [518, 1155],
      [518, 1139],
    ],
  },
  {
    zone: 'A111-1',
    coord: [
      [950, 1178],
      [1067, 1178],
      [1067, 1212],
      [966, 1212],
    ],
  },
  {
    zone: 'A111-2',
    coord: [
      [966, 1212],
      [1067, 1212],
      [1067, 1246],
      [982, 1246],
    ],
  },
  {
    zone: 'A112-1',
    coord: [
      [982, 1246],
      [1042, 1246],
      [1042, 1302],
      [1017, 1302],
    ],
  },
  {
    zone: 'A112-2',
    coord: [
      [1042, 1246],
      [1102, 1246],
      [1102, 1302],
      [1042, 1302],
    ],
  },
  {
    zone: 'A113',
    coord: [
      [1196, 1249],
      [1270, 1249],
      [1293, 1300],
      [1196, 1300],
    ],
  },
  {
    zone: 'A114',
    coord: [
      [1270, 1249],
      [1319, 1226],
      [1343, 1276],
      [1293, 1300],
    ],
  },
  {
    zone: 'A115',
    coord: [
      [1298, 1154],
      [1336, 1154],
      [1389, 1254],
      [1343, 1276],
      [1298, 1179],
    ],
  },
  {
    zone: 'A116',
    coord: [
      [1336, 1154],
      [1396, 1154],
      [1434, 1232],
      [1389, 1254],
    ],
  },
  {
    zone: 'A117',
    coord: [
      [1306, 1067],
      [1353, 1067],
      [1396, 1154],
      [1306, 1154],
    ],
  },
  {
    zone: 'A118',
    coord: [
      [1258, 1067],
      [1306, 1067],
      [1306, 1154],
      [1258, 1154],
    ],
  },
  {
    zone: 'A119',
    coord: [
      [1188, 1067],
      [1258, 1067],
      [1258, 1112],
      [1188, 1112],
    ],
  },
  {
    zone: 'A120',
    coord: [
      [1129, 1067],
      [1188, 1067],
      [1188, 1123],
      [1163, 1123],
      [1163, 1155],
      [1129, 1155],
    ],
  },
  {
    zone: 'A121',
    coord: [
      [1031, 1067],
      [1102, 1067],
      [1102, 1178],
      [1031, 1178],
    ],
  },
  {
    zone: 'A122',
    coord: [
      [972, 1067],
      [1031, 1067],
      [1031, 1178],
      [972, 1178],
    ],
  },
  {
    zone: 'A123',
    coord: [
      [900, 1067],
      [972, 1067],
      [972, 1178],
      [950, 1178],
    ],
  },
  {
    zone: 'B101',
    coord: [
      [172, 1134],
      [256, 1134],
      [256, 1187],
      [189, 1187],
    ],
  },
  {
    zone: 'B102',
    coord: [
      [256, 1134],
      [325, 1134],
      [325, 1187],
      [256, 1187],
    ],
  },
  {
    zone: 'B103',
    coord: [
      [325, 1134],
      [425, 1134],
      [390, 1187],
      [325, 1187],
    ],
  },
  {
    zone: 'B104-1',
    coord: [
      [390, 1073],
      [453, 1073],
      [460, 1084],
      [425, 1134],
      [390, 1134],
    ],
  },
  {
    zone: 'B104-2',
    coord: [
      [325, 1073],
      [390, 1073],
      [390, 1134],
      [325, 1134],
    ],
  },
  {
    zone: 'B105',
    coord: [
      [256, 1073],
      [325, 1073],
      [325, 1134],
      [256, 1134],
    ],
  },
  {
    zone: 'B106-1',
    coord: [
      [207, 1073],
      [256, 1073],
      [256, 1134],
      [207, 1134],
    ],
  },
  {
    zone: 'B106-2',
    coord: [
      [157, 1073],
      [207, 1073],
      [207, 1134],
      [172, 1134],
    ],
  },
  {
    zone: 'B107',
    coord: [
      [215, 844],
      [280, 844],
      [280, 992],
      [215, 992],
    ],
  },
  {
    zone: 'B108-1',
    coord: [
      [280, 918],
      [367, 918],
      [367, 992],
      [280, 992],
    ],
  },
  {
    zone: 'B108-2',
    coord: [
      [367, 918],
      [432, 918],
      [432, 992],
      [367, 992],
    ],
  },
  {
    zone: 'B109-1',
    coord: [
      [448, 941],
      [549, 941],
      [518, 992],
      [448, 992],
    ],
  },
  {
    zone: 'B109-2',
    coord: [
      [499, 845],
      [569, 845],
      [569, 909],
      [549, 941],
      [499, 941],
    ],
  },
  {
    zone: 'B110-1',
    coord: [
      [601, 787],
      [638, 787],
      [638, 917],
      [601, 917],
    ],
  },
  {
    zone: 'B110-2',
    coord: [
      [638, 787],
      [675, 787],
      [675, 917],
      [638, 917],
    ],
  },
  {
    zone: 'B111',
    coord: [
      [675, 787],
      [713, 787],
      [713, 917],
      [675, 917],
    ],
  },
  {
    zone: 'B112',
    coord: [
      [713, 787],
      [746, 787],
      [746, 917],
      [713, 917],
    ],
  },
  {
    zone: 'B113',
    coord: [
      [746, 787],
      [779, 787],
      [779, 917],
      [746, 917],
    ],
  },
  {
    zone: 'B114',
    coord: [
      [779, 787],
      [842, 787],
      [842, 917],
      [779, 917],
    ],
  },
  {
    zone: 'B115',
    coord: [
      [842, 787],
      [906, 787],
      [906, 917],
      [842, 917],
    ],
  },
  {
    zone: 'B116',
    coord: [
      [906, 787],
      [969, 787],
      [969, 957],
      [928, 957],
      [928, 917],
      [906, 917],
    ],
  },
  {
    zone: 'B117',
    coord: [
      [969, 787],
      [997, 787],
      [997, 957],
      [969, 957],
    ],
  },
  {
    zone: 'B118',
    coord: [
      [997, 787],
      [1025, 787],
      [1025, 957],
      [997, 957],
    ],
  },
  {
    zone: 'B119',
    coord: [
      [1025, 787],
      [1059, 787],
      [1059, 957],
      [1025, 957],
    ],
  },
  {
    zone: 'B120',
    coord: [
      [1059, 787],
      [1092, 787],
      [1092, 957],
      [1059, 957],
    ],
  },
  {
    zone: 'B121',
    coord: [
      [1092, 787],
      [1135, 787],
      [1135, 957],
      [1092, 957],
    ],
  },
  {
    zone: 'B122',
    coord: [
      [1135, 787],
      [1171, 787],
      [1171, 957],
      [1135, 957],
    ],
  },
  {
    zone: 'B123',
    coord: [
      [1177, 787],
      [1207, 787],
      [1207, 957],
      [1177, 957],
    ],
  },
  {
    zone: 'B124',
    coord: [
      [1207, 787],
      [1237, 787],
      [1237, 957],
      [1207, 957],
    ],
  },
  {
    zone: 'B125',
    coord: [
      [1237, 862],
      [1257, 862],
      [1298, 957],
      [1237, 957],
    ],
  },
  {
    zone: 'B126-1',
    coord: [
      [1298, 848],
      [1353, 848],
      [1353, 976],
      [1298, 871],
    ],
  },
  {
    zone: 'B126-2',
    coord: [
      [1353, 848],
      [1391, 848],
      [1391, 976],
      [1353, 976],
    ],
  },
  {
    zone: 'B127-1',
    coord: [
      [1402, 903],
      [1466, 903],
      [1466, 976],
      [1402, 976],
    ],
  },
  {
    zone: 'B127-2',
    coord: [
      [1466, 903],
      [1536, 903],
      [1536, 976],
      [1466, 976],
    ],
  },
  {
    zone: 'B128',
    coord: [
      [1578, 925],
      [1664, 925],
      [1664, 964],
      [1578, 964],
    ],
  },
  {
    zone: 'B129',
    coord: [
      [1611, 858],
      [1664, 858],
      [1664, 925],
      [1578, 925],
      [1578, 886],
      [1611, 886],
    ],
  },
  {
    zone: 'B130',
    coord: [
      [1578, 819],
      [1664, 819],
      [1664, 858],
      [1611, 858],
      [1611, 836],
      [1578, 836],
    ],
  },
  {
    zone: 'B131',
    coord: [
      [1578, 780],
      [1664, 780],
      [1664, 819],
      [1578, 819],
    ],
  },
  {
    zone: 'B132',
    coord: [
      [1578, 741],
      [1664, 741],
      [1664, 780],
      [1578, 780],
    ],
  },
];

export const spaceCoords1FAtti = [
  // FIXME Cb01 에 공간이 없어 보이는데, 있는지 확인 필요
  {
    zone: 'Cb02',
    coord: [
      [1563, 547],
      [1616, 547],
      [1598, 587],
      [1563, 587],
    ],
  },
  {
    zone: 'Cb03',
    coord: [
      [1563, 506],
      [1662, 506],
      [1662, 547],
      [1563, 547],
    ],
  },
  {
    zone: 'Cb04',
    coord: [
      [1563, 368],
      [1663, 368],
      [1663, 400],
      [1563, 400],
    ],
  },
  {
    zone: 'Cb05',
    coord: [
      [1563, 336],
      [1663, 336],
      [1663, 368],
      [1563, 368],
    ],
  },
  {
    zone: 'Cb06',
    coord: [
      [1563, 304],
      [1663, 304],
      [1663, 336],
      [1563, 336],
    ],
  },
  {
    zone: 'Cb07',
    coord: [
      [1563, 273],
      [1663, 273],
      [1663, 304],
      [1563, 304],
    ],
  },
  {
    zone: 'Cb08',
    coord: [
      [1563, 235],
      [1663, 235],
      [1663, 273],
      [1563, 273],
    ],
  },
  {
    zone: 'Cb09',
    coord: [
      [1573, 207],
      [1663, 207],
      [1663, 235],
      [1573, 235],
    ],
  },
  {
    zone: 'Cb10',
    coord: [
      [1573, 176],
      [1663, 176],
      [1663, 207],
      [1573, 207],
    ],
  },
  {
    zone: 'Cb11',
    coord: [
      [1573, 143],
      [1663, 143],
      [1663, 176],
      [1573, 176],
    ],
  },
  {
    zone: 'Cb12',
    coord: [
      [1451, 94],
      [1514, 94],
      [1514, 178],
      [1451, 178],
    ],
  },
  {
    zone: 'Cb13',
    coord: [
      [1405, 94],
      [1451, 94],
      [1451, 178],
      [1405, 178],
    ],
  },
  {
    zone: 'Cb14',
    coord: [
      [1386, 94],
      [1405, 94],
      [1405, 220],
      [1386, 220],
    ],
  },
  {
    zone: 'Cb15',
    coord: [
      [1361, 94],
      [1386, 94],
      [1386, 220],
      [1361, 220],
    ],
  },
  {
    zone: 'Cb16',
    coord: [
      [1334, 94],
      [1361, 94],
      [1361, 220],
      [1334, 220],
    ],
  },
  {
    zone: 'Cb17',
    coord: [
      [1294, 94],
      [1334, 94],
      [1334, 220],
      [1294, 220],
    ],
  },
  {
    zone: 'Cb18',
    coord: [
      [1253, 94],
      [1294, 94],
      [1294, 220],
      [1253, 220],
    ],
  },
  {
    zone: 'Cb19',
    coord: [
      [1218, 94],
      [1253, 94],
      [1253, 179],
      [1218, 179],
    ],
  },
  {
    zone: 'Cb20',
    coord: [
      [1183, 94],
      [1218, 94],
      [1218, 179],
      [1183, 179],
    ],
  },
  {
    zone: 'Cb21',
    coord: [
      [1125, 94],
      [1183, 94],
      [1183, 179],
      [1125, 179],
    ],
  },
  {
    zone: 'Cb22',
    coord: [
      [1074, 94],
      [1125, 94],
      [1125, 179],
      [1052, 179],
      [1052, 105],
      [1074, 105],
    ],
  },
  {
    zone: 'Cb23',
    coord: [
      [802, 94],
      [820, 94],
      [820, 105],
      [862, 105],
      [862, 152],
      [840, 152],
      [840, 178],
      [802, 178],
    ],
  },
  {
    zone: 'Cb24',
    coord: [
      [763, 94],
      [802, 94],
      [802, 178],
      [763, 178],
    ],
  },
  {
    zone: 'Cb25',
    coord: [
      [727, 94],
      [763, 94],
      [763, 178],
      [727, 178],
    ],
  },
  {
    zone: 'Cb26',
    coord: [
      [692, 94],
      [727, 94],
      [727, 178],
      [692, 178],
    ],
  },
  {
    zone: 'Cb27',
    coord: [
      [657, 94],
      [692, 94],
      [692, 178],
      [657, 178],
    ],
  },
  {
    zone: 'Cb28',
    coord: [
      [626, 94],
      [657, 94],
      [657, 178],
      [626, 178],
    ],
  },
  {
    zone: 'Cb29',
    coord: [
      [594, 94],
      [626, 94],
      [626, 178],
      [594, 178],
    ],
  },
  {
    zone: 'Cb30',
    coord: [
      [559, 94],
      [594, 94],
      [594, 215],
      [559, 215],
    ],
  },
  {
    zone: 'Cb31',
    coord: [
      [519, 94],
      [559, 94],
      [559, 215],
      [519, 215],
    ],
  },
  {
    zone: 'Cb32',
    coord: [
      [484, 94],
      [519, 94],
      [519, 215],
      [484, 215],
    ],
  },
  {
    zone: 'Cb33',
    coord: [
      [434, 94],
      [484, 94],
      [484, 215],
      [434, 215],
    ],
  },
  {
    zone: 'Cb34',
    coord: [
      [343, 94],
      [434, 94],
      [434, 154],
      [343, 154],
    ],
  },
  {
    zone: 'Cb35-1',
    coord: [
      [139, 168],
      [241, 168],
      [241, 200],
      [139, 200],
    ],
  },
  {
    zone: 'Cb35-2',
    coord: [
      [139, 200],
      [241, 200],
      [241, 232],
      [139, 232],
    ],
  },
  {
    zone: 'Cb36-1',
    coord: [
      [139, 232],
      [241, 232],
      [241, 263],
      [139, 263],
    ],
  },
  {
    zone: 'Cb36-2',
    coord: [
      [139, 263],
      [241, 263],
      [241, 295],
      [139, 295],
    ],
  },
  {
    zone: 'Cb37-1',
    coord: [
      [139, 295],
      [290, 295],
      [290, 328],
      [139, 328],
    ],
  },
  {
    zone: 'Cb37-2',
    coord: [
      [139, 328],
      [290, 328],
      [290, 358],
      [139, 358],
    ],
  },
  {
    zone: 'Cb38-1',
    coord: [
      [139, 358],
      [290, 358],
      [290, 421],
      [139, 421],
    ],
  },
  {
    zone: 'Cb38-2',
    coord: [
      [139, 421],
      [290, 421],
      [290, 467],
      [139, 467],
    ],
  },
  {
    zone: 'Cb39',
    coord: [
      [139, 467],
      [259, 467],
      [259, 516],
      [139, 516],
    ],
  },
  {
    zone: 'Cb40-1',
    coord: [
      [139, 516],
      [259, 516],
      [259, 566],
      [139, 566],
    ],
  },
  {
    zone: 'Cb40-2',
    coord: [
      [139, 566],
      [290, 566],
      [290, 609],
      [139, 609],
    ],
  },
];

export const spaceCoords2FAtti = [
  {
    zone: 'C101',
    coord: [
      [1598, 586],
      [1689, 586],
      [1689, 632],
      [1598, 632],
    ],
  },
  {
    zone: 'C102',
    coord: [
      [1598, 516],
      [1689, 516],
      [1689, 586],
      [1598, 586],
    ],
  },
  {
    zone: 'C103',
    coord: [
      [1598, 443],
      [1689, 443],
      [1689, 516],
      [1598, 516],
    ],
  },
  {
    zone: 'C104',
    coord: [
      [1598, 383],
      [1689, 383],
      [1689, 443],
      [1598, 443],
    ],
  },
  {
    zone: 'C105',
    coord: [
      [1598, 324],
      [1689, 324],
      [1689, 383],
      [1598, 383],
    ],
  },
  {
    zone: 'C106',
    coord: [
      [1618, 256],
      [1689, 256],
      [1689, 324],
      [1618, 324],
    ],
  },
  {
    zone: 'C107',
    coord: [
      [1618, 188],
      [1689, 188],
      [1689, 256],
      [1618, 256],
    ],
  },
  {
    zone: 'C108',
    coord: [
      [1618, 121],
      [1689, 121],
      [1689, 188],
      [1618, 188],
    ],
  },
  {
    zone: 'C109',
    coord: [
      [1400, 121],
      [1517, 121],
      [1517, 199],
      [1400, 199],
    ],
  },
  {
    zone: 'C110',
    coord: [
      [1354, 121],
      [1400, 121],
      [1400, 236],
      [1354, 236],
    ],
  },
  {
    zone: 'C111',
    coord: [
      [1307, 121],
      [1354, 121],
      [1354, 236],
      [1307, 236],
    ],
  },
  {
    zone: 'C112',
    coord: [
      [1220, 121],
      [1307, 121],
      [1307, 236],
      [1220, 236],
    ],
  },
  {
    zone: 'C113',
    coord: [
      [1152, 121],
      [1220, 121],
      [1220, 205],
      [1152, 205],
    ],
  },
  {
    zone: 'C114-1',
    coord: [
      [1084, 121],
      [1152, 121],
      [1152, 205],
      [1084, 205],
    ],
  },
  {
    zone: 'C114-2',
    coord: [
      [1084, 121],
      [1084, 121],
      [1084, 205],
      [1048, 205],
    ],
  },
  {
    zone: 'C115',
    coord: [
      [687, 121],
      [822, 121],
      [822, 179],
      [774, 179],
      [774, 213],
      [687, 213],
    ],
  },
  {
    zone: 'C116',
    coord: [
      [632, 121],
      [687, 121],
      [687, 213],
      [632, 213],
    ],
  },
  {
    zone: 'C117',
    coord: [
      [578, 121],
      [632, 121],
      [632, 213],
      [578, 213],
    ],
  },
  {
    zone: 'C118',
    coord: [
      [524, 121],
      [578, 121],
      [578, 213],
      [524, 213],
    ],
  },
  {
    zone: 'C119',
    coord: [
      [485, 121],
      [524, 121],
      [524, 235],
      [485, 235],
    ],
  },
  {
    zone: 'C120',
    coord: [
      [407, 121],
      [485, 121],
      [485, 235],
      [437, 235],
      [437, 185],
      [407, 185],
    ],
  },
  {
    zone: 'C121',
    coord: [
      [255, 121],
      [407, 121],
      [407, 185],
      [330, 185],
      [330, 209],
      [255, 209],
    ],
  },
  {
    zone: 'C122',
    coord: [
      [92, 121],
      [177, 121],
      [177, 197],
      [92, 197],
    ],
  },
  {
    zone: 'C123',
    coord: [
      [92, 197],
      [177, 197],
      [177, 273],
      [92, 273],
    ],
  },
  {
    zone: 'C124',
    coord: [
      [92, 273],
      [177, 273],
      [177, 348],
      [92, 348],
    ],
  },
  {
    zone: 'C125',
    coord: [
      [92, 348],
      [201, 348],
      [201, 419],
      [92, 419],
    ],
  },
  {
    zone: 'C126',
    coord: [
      [92, 419],
      [201, 419],
      [201, 490],
      [92, 490],
    ],
  },
  {
    zone: 'C127-1',
    coord: [
      [92, 490],
      [201, 490],
      [201, 559],
      [92, 559],
    ],
  },
  {
    zone: 'C127-2',
    coord: [
      [92, 559],
      [201, 559],
      [201, 592],
      [92, 592],
    ],
  },
  {
    zone: 'C128',
    coord: [
      [92, 592],
      [201, 592],
      [201, 626],
      [92, 626],
    ],
  },
];

export const spaceCoords2FRaon = [
  {
    zone: 'A201-1',
    coord: [
      [515, 1087],
      [558, 1115],
      [558, 1155],
      [473, 1155],
    ],
  },
  {
    zone: 'A201-2',
    coord: [
      [473, 1155],
      [517, 1155],
      [517, 1215],
      [434, 1215],
    ],
  },
  {
    zone: 'A202-1',
    coord: [
      [434, 1215],
      [517, 1215],
      [517, 1290],
      [415, 1290],
      [415, 1242],
    ],
  },
  {
    zone: 'A202-2',
    coord: [
      [517, 1215],
      [584, 1215],
      [584, 1290],
      [517, 1290],
    ],
  },
  {
    zone: 'A203',
    coord: [
      [584, 1215],
      [652, 1215],
      [652, 1290],
      [584, 1290],
    ],
  },
  {
    zone: 'A204',
    coord: [
      [652, 1215],
      [713, 1215],
      [745, 1279],
      [720, 1290],
      [652, 1290],
    ],
  },
  {
    zone: 'A205',
    coord: [
      [713, 1215],
      [790, 1179],
      [822, 1243],
      [745, 1279],
    ],
  },
  {
    zone: 'A206',
    coord: [
      [790, 1179],
      [843, 1154],
      [874, 1218],
      [822, 1243],
    ],
  },
  {
    zone: 'A207',
    coord: [
      [667, 1051],
      [757, 1051],
      [757, 1132],
      [667, 1132],
    ],
  },
  {
    zone: 'A208',
    coord: [
      [621, 1051],
      [667, 1051],
      [667, 1132],
      [621, 1132],
    ],
  },
  {
    zone: 'A209',
    coord: [
      [541, 1051],
      [621, 1051],
      [621, 1132],
      [530, 1069],
    ],
  },
  {
    zone: 'A210',
    coord: [
      [936, 1149],
      [1005, 1149],
      [1005, 1294],
    ],
  },
  {
    zone: 'A211',
    coord: [
      [1005, 1211],
      [1078, 1211],
      [1078, 1294],
      [1005, 1294],
    ],
  },
  {
    zone: 'A212',
    coord: [
      [1078, 1211],
      [1151, 1211],
      [1151, 1294],
      [1078, 1294],
    ],
  },
  {
    zone: 'A213',
    coord: [
      [1151, 1211],
      [1224, 1211],
      [1224, 1294],
      [1151, 1294],
    ],
  },
  {
    zone: 'A214',
    coord: [
      [1224, 1211],
      [1297, 1211],
      [1297, 1294],
      [1224, 1294],
    ],
  },
  {
    zone: 'A215',
    coord: [
      [1268, 1149],
      [1370, 1149],
      [1370, 1294],
      [1297, 1294],
      [1297, 1211],
    ],
  },
  {
    zone: 'A216',
    coord: [
      [1370, 1149],
      [1462, 1149],
      [1470, 1165],
      [1470, 1294],
      [1370, 1294],
    ],
  },
  {
    zone: 'A217',
    coord: [
      [1470, 1165],
      [1570, 1165],
      [1570, 1294],
      [1470, 1294],
    ],
  },
  {
    zone: 'A218',
    coord: [
      [1244, 1106],
      [1440, 1106],
      [1462, 1149],
      [1244, 1149],
    ],
  },
  {
    zone: 'A219',
    coord: [
      [1244, 1063],
      [1418, 1063],
      [1440, 1106],
      [1244, 1106],
    ],
  },
  {
    zone: 'A220',
    coord: [
      [1244, 1020],
      [1398, 1020],
      [1418, 1063],
      [1244, 1063],
    ],
  },
  {
    zone: 'A221',
    coord: [
      [1152, 1020],
      [1204, 1020],
      [1204, 1131],
      [1152, 1131],
    ],
  },
  {
    zone: 'A222',
    coord: [
      [1099, 1020],
      [1152, 1020],
      [1152, 1131],
      [1099, 1131],
    ],
  },
  {
    zone: 'A223',
    coord: [
      [1016, 1020],
      [1099, 1020],
      [1099, 1131],
      [1016, 1131],
    ],
  },
  {
    zone: 'A224',
    coord: [
      [920, 1020],
      [1016, 1020],
      [1016, 1131],
      [971, 1131],
    ],
  },
  {
    zone: 'B201',
    coord: [
      [87, 1111],
      [133, 1111],
      [133, 1251],
      [87, 1251],
    ],
  },
  {
    zone: 'B202-1',
    coord: [
      [133, 1111],
      [175, 1111],
      [175, 1251],
      [133, 1251],
    ],
  },
  {
    zone: 'B202-2',
    coord: [
      [175, 1111],
      [217, 1111],
      [217, 1251],
      [175, 1251],
    ],
  },
  {
    zone: 'B203-1',
    coord: [
      [217, 1111],
      [262, 1111],
      [262, 1251],
      [217, 1251],
    ],
  },
  {
    zone: 'B203-2',
    coord: [
      [262, 1111],
      [327, 1111],
      [314, 1127],
      [314, 1177],
      [262, 1251],
    ],
  },
  {
    zone: 'B204-1',
    coord: [
      [279, 1020],
      [357, 1069],
      [327, 1111],
      [217, 1111],
    ],
  },
  {
    zone: 'B204-2',
    coord: [
      [332, 941],
      [407, 991],
      [357, 1069],
      [279, 1020],
    ],
  },
  {
    zone: 'B205-1',
    coord: [
      [352, 912],
      [448, 977],
      [419, 1011],
      [332, 941],
    ],
  },
  {
    zone: 'B205-2',
    coord: [
      [369, 886],
      [467, 950],
      [448, 977],
      [352, 912],
    ],
  },
  {
    zone: 'B206-1',
    coord: [
      [378, 872],
      [445, 890],
      [489, 917],
      [467, 950],
      [369, 886],
    ],
  },
  {
    zone: 'B206-2',
    coord: [
      [465, 862],
      [507, 890],
      [489, 917],
      [445, 890],
    ],
  },
  {
    zone: 'B207-1',
    coord: [
      [500, 757],
      [545, 757],
      [545, 865],
      [527, 865],
      [512, 876],
      [466, 842],
      [500, 793],
    ],
  },
  {
    zone: 'B207-2',
    coord: [
      [545, 757],
      [596, 757],
      [596, 865],
      [545, 865],
    ],
  },
  {
    zone: 'B208',
    coord: [
      [596, 757],
      [638, 757],
      [638, 865],
      [596, 865],
    ],
  },
  {
    zone: 'B209',
    coord: [
      [638, 757],
      [681, 757],
      [681, 865],
      [638, 865],
    ],
  },
  {
    zone: 'B210',
    coord: [
      [681, 757],
      [724, 757],
      [724, 865],
      [681, 865],
    ],
  },
  {
    zone: 'B211',
    coord: [
      [724, 757],
      [767, 757],
      [767, 865],
      [724, 865],
    ],
  },
  {
    zone: 'B212',
    coord: [
      [767, 757],
      [813, 757],
      [813, 865],
      [767, 865],
    ],
  },
  {
    zone: 'B213',
    coord: [
      [813, 757],
      [859, 757],
      [859, 865],
      [813, 865],
    ],
  },
  {
    zone: 'B214',
    coord: [
      [859, 757],
      [905, 757],
      [905, 865],
      [859, 865],
    ],
  },
  {
    zone: 'B215',
    coord: [
      [955, 821],
      [999, 821],
      [999, 910],
      [955, 910],
    ],
  },
  {
    zone: 'B216',
    coord: [
      [999, 821],
      [1042, 821],
      [1042, 910],
      [999, 910],
    ],
  },
  {
    zone: 'B217',
    coord: [
      [1042, 821],
      [1088, 821],
      [1088, 910],
      [1042, 910],
    ],
  },
  {
    zone: 'B218',
    coord: [
      [1088, 821],
      [1133, 821],
      [1133, 910],
      [1088, 910],
    ],
  },
  {
    zone: 'B219',
    coord: [
      [1133, 821],
      [1177, 821],
      [1177, 910],
      [1133, 910],
    ],
  },
  {
    zone: 'B220',
    coord: [
      [1177, 821],
      [1221, 821],
      [1221, 910],
      [1177, 910],
    ],
  },
  {
    zone: 'B221',
    coord: [
      [1221, 821],
      [1266, 821],
      [1266, 910],
      [1221, 910],
    ],
  },
  {
    zone: 'B222',
    coord: [
      [1266, 821],
      [1310, 821],
      [1310, 910],
      [1266, 910],
    ],
  },
  {
    zone: 'B223',
    coord: [
      [1310, 821],
      [1354, 821],
      [1354, 910],
      [1310, 910],
    ],
  },
  {
    zone: 'B224',
    coord: [
      [1354, 821],
      [1398, 821],
      [1398, 910],
      [1354, 910],
    ],
  },
  {
    zone: 'B225',
    coord: [
      [1398, 821],
      [1443, 821],
      [1443, 910],
      [1398, 910],
    ],
  },
  {
    zone: 'B226',
    coord: [
      [1443, 821],
      [1487, 821],
      [1487, 910],
      [1443, 910],
    ],
  },
  {
    zone: 'B227',
    coord: [
      [1584, 893],
      [1695, 893],
      [1688, 928],
      [1669, 946],
      [1584, 946],
    ],
  },
  {
    zone: 'B228',
    coord: [
      [1584, 827],
      [1707, 827],
      [1695, 893],
      [1584, 893],
    ],
  },
  {
    zone: 'B229',
    coord: [
      [1584, 796],
      [1673, 796],
      [1673, 827],
      [1584, 827],
    ],
  },
  {
    zone: 'B230-1',
    coord: [
      [1584, 766],
      [1673, 766],
      [1673, 796],
      [1584, 796],
    ],
  },
  {
    zone: 'B230-2',
    coord: [
      [1584, 736],
      [1673, 736],
      [1673, 766],
      [1584, 766],
    ],
  },
];

export const spaceCoordsB1FRaon = [
  {
    zone: 'Ab00',
    coord: [
      [117, 486],
      [1415, 486],
      [1415, 855],
      [117, 855],
    ],
  },
  {
    zone: 'Ab01-1',
    coord: [
      [116, 971],
      [160, 971],
      [160, 1117],
      [116, 1117],
    ],
  },
  {
    zone: 'Ab01-2',
    coord: [
      [160, 971],
      [198, 971],
      [198, 1117],
      [160, 1117],
    ],
  },
  {
    zone: 'Ab02',
    coord: [
      [198, 971],
      [277, 971],
      [277, 1117],
      [198, 1117],
    ],
  },
  {
    zone: 'Ab03-1',
    coord: [
      [277, 971],
      [313, 971],
      [313, 1117],
      [277, 1117],
    ],
  },
  {
    zone: 'Ab03-2',
    coord: [
      [313, 971],
      [349, 971],
      [349, 1117],
      [313, 1117],
    ],
  },
  {
    zone: 'Ab04-1',
    coord: [
      [349, 971],
      [410, 971],
      [410, 1141],
      [349, 1141],
    ],
  },
  {
    zone: 'Ab04-2',
    coord: [
      [410, 971],
      [470, 971],
      [470, 1042],
      [512, 1042],
      [512, 1141],
      [410, 1141],
    ],
  },
  {
    zone: 'Ab05',
    coord: [
      [695, 971],
      [747, 971],
      [747, 1141],
      [684, 1141],
      [684, 1041],
      [713, 1022],
    ],
  },
  {
    zone: 'Ab06',
    coord: [
      [747, 971],
      [800, 971],
      [800, 1141],
      [747, 1141],
    ],
  },
  {
    zone: 'Ab07-1 ',
    coord: [
      [800, 971],
      [843, 971],
      [843, 1141],
      [800, 1141],
    ],
  },
  {
    zone: 'Ab07-2',
    coord: [
      [843, 971],
      [886, 971],
      [886, 1141],
      [843, 1141],
    ],
  },
  {
    zone: 'Ab08-1',
    coord: [
      [886, 971],
      [931, 971],
      [931, 1141],
      [886, 1141],
    ],
  },
  {
    zone: 'Ab08-2',
    coord: [
      [931, 971],
      [982, 971],
      [982, 1141],
      [931, 1141],
    ],
  },
  {
    zone: 'Ab09',
    coord: [
      [982, 1041],
      [1141, 1041],
      [1141, 1141],
      [982, 1141],
    ],
  },
  {
    zone: 'Ab10',
    coord: [
      [1204, 971],
      [1300, 971],
      [1300, 1090],
      [1239, 1090],
      [1239, 1141],
      [1141, 1141],
      [1141, 1041],
      [1204, 1041],
    ],
  },
  {
    zone: 'Ab11',
    coord: [
      [1300, 971],
      [1286, 971],
      [1415, 1035],
      [1300, 1090],
    ],
  },
  {
    zone: 'Ab12',
    coord: [
      [1239, 1090],
      [1369, 1090],
      [1369, 1141],
      [1239, 1141],
    ],
  },
  {
    zone: 'Ab13',
    coord: [
      [1454, 1089],
      [1595, 1088],
      [1595, 1141],
      [1454, 1141],
    ],
  },
  {
    zone: 'Bb01',
    coord: [
      [1579, 998],
      [1700, 998],
      [1700, 1088],
      [1595, 1088],
      [1595, 1030],
    ],
  },
  {
    zone: 'Bb02',
    coord: [
      [1549, 940],
      [1700, 940],
      [1700, 998],
      [1579, 998],
    ],
  },
  {
    zone: 'Bb03',
    coord: [
      [1528, 898],
      [1700, 898],
      [1700, 940],
      [1549, 940],
    ],
  },
  {
    zone: 'Bb04',
    coord: [
      [1500, 790],
      [1700, 845],
      [1700, 898],
      [1528, 898],
    ],
  },
  {
    zone: 'Bb05',
    coord: [
      [1472, 790],
      [1700, 790],
      [1700, 845],
      [1500, 790],
    ],
  },
  {
    zone: 'Bb06',
    coord: [
      [1465, 642],
      [1700, 642],
      [1700, 790],
      [1472, 790],
      [1465, 775],
    ],
  },
  {
    zone: 'Bb07',
    coord: [
      [1465, 478],
      [1700, 478],
      [1700, 642],
      [1465, 642],
    ],
  },
  {
    zone: 'Bb08',
    coord: [
      [1543, 395],
      [1700, 395],
      [1700, 478],
      [1465, 478],
    ],
  },
  {
    zone: 'Bb09',
    coord: [
      [1623, 312],
      [1700, 312],
      [1700, 395],
      [1543, 395],
    ],
  },
  {
    zone: 'Bb10',
    coord: [
      [1467, 354],
      [1467, 464],
      [1346, 464],
    ],
  },
  {
    zone: 'Cb01',
    coord: [
      [1491, 233],
      [1589, 233],
      [1611, 257],
      [1561, 312],
      [1484, 318],
    ],
  },
];

export const parkingCoordB2F = [
  {
    zone: 'A01',
    coord: [356, 1164],
    default_pano: 28025,
  },
  {
    zone: 'A02',
    coord: [270, 1040],
    default_pano: 28146,
  },
  {
    zone: 'A03',
    coord: [328, 1082],
    default_pano: 28025,
  },
  {
    zone: 'A04',
    coord: [390, 1040],
    default_pano: 28134,
  },
  {
    zone: 'A05',
    coord: [452, 1082],
    default_pano: 28027,
  },
  {
    zone: 'A06',
    coord: [696, 1082],
    default_pano: 28030,
  },
  {
    zone: 'A07',
    coord: [778, 1040],
    default_pano: 28114,
  },
  {
    zone: 'A08',
    coord: [856, 1082],
    default_pano: 28003,
  },
  {
    zone: 'A09',
    coord: [938, 1040],
    default_pano: 28102,
  },
  {
    zone: 'A10',
    coord: [1018, 1082],
    default_pano: 28037,
  },
  {
    zone: 'A11',
    coord: [1106, 1040],
    default_pano: 28093,
  },
  {
    zone: 'A12',
    coord: [1344, 1082],
    default_pano: 28045,
  },
  {
    zone: 'A13',
    coord: [1344, 1040],
    default_pano: 28077,
  },
  {
    zone: 'A14',
    coord: [1568, 1040],
    default_pano: 28064,
  },
  {
    zone: 'A15',
    coord: [1636, 1172],
    default_pano: 28055,
  },
  {
    zone: 'A16',
    coord: [1568, 1082],
    default_pano: 28052,
  },
  {
    zone: 'A17',
    coord: [1566, 1172],
    default_pano: 28052,
  },
  {
    zone: 'A18',
    coord: [1260, 1172],
    default_pano: 28043,
  },
  {
    zone: 'A19',
    coord: [1094, 1172],
    default_pano: 28039,
  },
  {
    zone: 'B01',
    coord: [448, 962],
    default_pano: 28134,
  },
  {
    zone: 'B02',
    coord: [326, 962],
    default_pano: 28140,
  },
  {
    zone: 'B03',
    coord: [126, 970],
    default_pano: 28213,
  },
  {
    zone: 'B04',
    coord: [226, 908],
    default_pano: 28213,
  },
  {
    zone: 'B05',
    coord: [126, 838],
    default_pano: 28210,
  },
  {
    zone: 'B06',
    coord: [226, 834],
    default_pano: 28210,
  },
  {
    zone: 'B07',
    coord: [328, 790],
    default_pano: 28204,
  },
  {
    zone: 'B08',
    coord: [270, 704],
    default_pano: 28204,
  },
  {
    zone: 'B09',
    coord: [126, 720],
    default_pano: 28198,
  },
  {
    zone: 'B10',
    coord: [330, 662],
    default_pano: 28059,
  },
  {
    zone: 'B11',
    coord: [456, 662],
    default_pano: 28065,
  },
  {
    zone: 'B12',
    coord: [532, 722],
    default_pano: 28180,
  },
  {
    zone: 'B13',
    coord: [532, 790],
    default_pano: 28138,
  },
  {
    zone: 'B14',
    coord: [532, 902],
    default_pano: 28128,
  },
  {
    zone: 'B15',
    coord: [698, 956],
    default_pano: 28118,
  },
  {
    zone: 'B16',
    coord: [858, 956],
    default_pano: 28110,
  },
  {
    zone: 'B17',
    coord: [1020, 956],
    default_pano: 28102,
  },
  {
    zone: 'B18',
    coord: [1366, 934],
    default_pano: 28075,
  },
  {
    zone: 'B19',
    coord: [1102, 918],
    default_pano: 28097,
  },
  {
    zone: 'B20',
    coord: [1020, 836],
    default_pano: 28104,
  },
  {
    zone: 'B21',
    coord: [938, 918],
    default_pano: 28104,
  },
  {
    zone: 'B22',
    coord: [858, 836],
    default_pano: 28112,
  },
  {
    zone: 'B23',
    coord: [778, 918],
    default_pano: 28112,
  },
  {
    zone: 'B24',
    coord: [698, 836],
    default_pano: 28120,
  },
  {
    zone: 'B25',
    coord: [778, 796],
    default_pano: 28145,
  },
  {
    zone: 'B26',
    coord: [938, 796],
    default_pano: 28152,
  },
  {
    zone: 'B27',
    coord: [1100, 796],
    default_pano: 28164,
  },
  {
    zone: 'B28',
    coord: [1338, 796],
    default_pano: 28171,
  },
  {
    zone: 'C01',
    coord: [388, 578],
    default_pano: 28062,
  },
  {
    zone: 'C02',
    coord: [270, 578],
    default_pano: 28065,
  },
  {
    zone: 'C03',
    coord: [128, 596],
    default_pano: 28225,
  },
  {
    zone: 'C04',
    coord: [128, 532],
    default_pano: 28224,
  },
  {
    zone: 'C05',
    coord: [128, 445],
    default_pano: 28221,
  },
  {
    zone: 'C06',
    coord: [298, 420],
    default_pano: 28088,
  },
  {
    zone: 'C07',
    coord: [402, 418],
    default_pano: 28091,
  },
  {
    zone: 'C08',
    coord: [476, 418],
    default_pano: 28099,
  },
  {
    zone: 'C09',
    coord: [530, 456],
    default_pano: 28160,
  },
  {
    zone: 'C10',
    coord: [530, 540],
    default_pano: 28162,
  },
  {
    zone: 'C11',
    coord: [628, 555],
    default_pano: 28166,
  },
  {
    zone: 'C12',
    coord: [628, 436],
    default_pano: 28107,
  },
  {
    zone: 'C13',
    coord: [884, 418],
    default_pano: 28123,
  },
  {
    zone: 'C14',
    coord: [1014, 418],
    default_pano: 28131,
  },
  {
    zone: 'C15',
    coord: [1134, 418],
    default_pano: 28142,
  },
  {
    zone: 'C16',
    coord: [1164, 466],
    default_pano: 28121,
  },
  {
    zone: 'C17',
    coord: [1252, 424],
    default_pano: 28121,
  },
  {
    zone: 'C18',
    coord: [1164, 526],
    default_pano: 28113,
  },
  {
    zone: 'C19',
    coord: [1252, 568],
    default_pano: 28113,
  },
  {
    zone: 'C20',
    coord: [1342, 578],
    default_pano: 28100,
  },
  {
    zone: 'C21',
    coord: [1344, 680],
    default_pano: 28100,
  },
  {
    zone: 'C22',
    coord: [1130, 582],
    default_pano: 28096,
  },
  {
    zone: 'C23',
    coord: [1122, 668],
    default_pano: 28096,
  },
  {
    zone: 'C24',
    coord: [1000, 580],
    default_pano: 28089,
  },
  {
    zone: 'C25',
    coord: [938, 664],
    default_pano: 28089,
  },
  {
    zone: 'C26',
    coord: [866, 580],
    default_pano: 28083,
  },
  {
    zone: 'C27',
    coord: [740, 670],
    default_pano: 28076,
  },
  {
    zone: 'C28',
    coord: [720, 578],
    default_pano: 28076,
  },
  {
    zone: 'C29',
    coord: [708, 710],
    default_pano: 28145,
  },
  {
    zone: 'C30',
    coord: [858, 710],
    default_pano: 28150,
  },
  {
    zone: 'C31',
    coord: [1052, 710],
    default_pano: 28161,
  },
  {
    zone: 'D01',
    coord: [408, 326],
    default_pano: 28091,
  },
  {
    zone: 'D02',
    coord: [298, 326],
    default_pano: 28088,
  },
  {
    zone: 'D03',
    coord: [126, 344],
    default_pano: 28082,
  },
  {
    zone: 'D04',
    coord: [224, 300],
    default_pano: 28220,
  },
  {
    zone: 'D05',
    coord: [126, 220],
    default_pano: 28219,
  },
  {
    zone: 'D06',
    coord: [226, 222],
    default_pano: 28219,
  },
  {
    zone: 'D07',
    coord: [126, 124],
    default_pano: 28217,
  },
  {
    zone: 'D08',
    coord: [198, 82],
    default_pano: 28216,
  },
  {
    zone: 'D09',
    coord: [252, 166],
    default_pano: 28216,
  },
  {
    zone: 'D10',
    coord: [290, 82],
    default_pano: 28214,
  },
  {
    zone: 'D11',
    coord: [366, 82],
    default_pano: 28212,
  },
  {
    zone: 'D12',
    coord: [418, 82],
    default_pano: 28211,
  },
  {
    zone: 'D13',
    coord: [412, 164],
    default_pano: 28211,
  },
  {
    zone: 'D14',
    coord: [516, 82],
    default_pano: 28201,
  },
  {
    zone: 'D15',
    coord: [526, 220],
    default_pano: 28205,
  },
  {
    zone: 'D16',
    coord: [526, 320],
    default_pano: 28208,
  },
  {
    zone: 'D17',
    coord: [606, 166],
    default_pano: 28199,
  },
  {
    zone: 'D18',
    coord: [636, 82],
    default_pano: 28196,
  },
  {
    zone: 'D19',
    coord: [690, 166],
    default_pano: 28194,
  },
  {
    zone: 'D20',
    coord: [758, 82],
    default_pano: 28194,
  },
  {
    zone: 'D21',
    coord: [898, 166],
    default_pano: 28189,
  },
  {
    zone: 'D22',
    coord: [942, 90],
    default_pano: 28189,
  },
  {
    zone: 'D23',
    coord: [1014, 166],
    default_pano: 28187,
  },
  {
    zone: 'D24',
    coord: [1102, 88],
    default_pano: 28185,
  },
  {
    zone: 'D25',
    coord: [1190, 172],
    default_pano: 28178,
  },
  {
    zone: 'D26',
    coord: [1222, 90],
    default_pano: 28175,
  },
  {
    zone: 'D27',
    coord: [1310, 172],
    default_pano: 28172,
  },
  {
    zone: 'D28',
    coord: [1344, 82],
    default_pano: 28169,
  },
  {
    zone: 'D29',
    coord: [1380, 236],
    default_pano: 28165,
  },
  {
    zone: 'D30',
    coord: [1470, 266],
    default_pano: 28163,
  },
  {
    zone: 'D31',
    coord: [1450, 344],
    default_pano: 28155,
  },
  {
    zone: 'D32',
    coord: [1384, 322],
    default_pano: 28159,
  },
  {
    zone: 'D33',
    coord: [1100, 330],
    default_pano: 28135,
  },
  {
    zone: 'D34',
    coord: [998, 326],
    default_pano: 28129,
  },
  {
    zone: 'D35',
    coord: [878, 326],
    default_pano: 28119,
  },
];

export const parkingCoordB3F = [
  {
    zone: 'A01',
    coord: [580, 842],
    default_pano: 27390,
  },
  {
    zone: 'A02',
    coord: [508, 838],
    default_pano: 27367,
  },
  {
    zone: 'A03',
    coord: [322, 872],
    default_pano: 27370,
  },
  {
    zone: 'A04',
    coord: [152, 890],
    default_pano: 27372,
  },
  {
    zone: 'A05',
    coord: [152, 838],
    default_pano: 27373,
  },
  {
    zone: 'A06',
    coord: [152, 588],
    default_pano: 27378,
  },
  {
    zone: 'A07',
    coord: [152, 470],
    default_pano: 27376,
  },
  {
    zone: 'A08',
    coord: [252, 458],
    default_pano: 27376,
  },
  {
    zone: 'A09',
    coord: [252, 526],
    default_pano: 27377,
  },
  {
    zone: 'A10',
    coord: [292, 590],
    default_pano: 27380,
  },
  {
    zone: 'A11',
    coord: [288, 678],
    default_pano: 27383,
  },
  {
    zone: 'A12',
    coord: [418, 698],
    default_pano: 27384,
  },
  {
    zone: 'A13',
    coord: [348, 786],
    default_pano: 27384,
  },
  {
    zone: 'A14',
    coord: [524, 698],
    default_pano: 27386,
  },
  {
    zone: 'A15',
    coord: [760, 698],
    default_pano: 27392,
  },
  {
    zone: 'A16',
    coord: [952, 698],
    default_pano: 27394,
  },
  {
    zone: 'A17',
    coord: [1152, 698],
    default_pano: 27397,
  },
  {
    zone: 'A18',
    coord: [1140, 790],
    default_pano: 27397,
  },
  {
    zone: 'A19',
    coord: [1346, 790],
    default_pano: 27401,
  },
  {
    zone: 'A20',
    coord: [1428, 790],
    default_pano: 27402,
  },
  {
    zone: 'A21',
    coord: [1428, 700],
    default_pano: 27402,
  },
  {
    zone: 'A22',
    coord: [1556, 790],
    default_pano: 27404,
  },
  {
    zone: 'A23',
    coord: [1636, 700],
    default_pano: 27404,
  },
];
